import {createLargeSvgIcon} from './utils'

export default createLargeSvgIcon(
  <>
    <g clipPath="url(#clip0_12_212)">
      <mask height="41" id="mask0_12_212" maskUnits="userSpaceOnUse" style={{maskType: 'alpha'}} width="40" x="0" y="0">
        <path
          d="M0 19.2002C0 12.4796 0 9.1193 1.30792 6.55236C2.4584 4.29441 4.29417 2.45865 6.55211 1.30817C9.11906 0.000244141 12.4794 0.000244141 19.2 0.000244141H20.8C27.5206 0.000244141 30.8809 0.000244141 33.4479 1.30817C35.7058 2.45865 37.5416 4.29441 38.6921 6.55236C40 9.1193 40 12.4796 40 19.2002V20.8002C40 27.5209 40 30.8812 38.6921 33.4481C37.5416 35.7061 35.7058 37.5418 33.4479 38.6923C30.8809 40.0002 27.5206 40.0002 20.8 40.0002H19.2C12.4794 40.0002 9.11906 40.0002 6.55211 38.6923C4.29417 37.5418 2.4584 35.7061 1.30792 33.4481C0 30.8812 0 27.5209 0 20.8002V19.2002Z"
          fill="white"
        />
      </mask>
      <g mask="url(#mask0_12_212)">
        <rect fill="#2B2A28" height="20" width="20" x="20" y="20.0002" />
        <rect fill="url(#paint0_linear_12_212)" height="20" width="20" y="20.0002" />
        <rect fill="url(#paint1_linear_12_212)" height="20" width="40" y="0.000244141" />
      </g>
    </g>
    <defs>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint0_linear_12_212"
        x1="10"
        x2="10"
        y1="20.0002"
        y2="40.0002"
      >
        <stop stopColor="#F2F1EF" />
        <stop offset="1" stopColor="#FCF8E8" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint1_linear_12_212"
        x1="20"
        x2="20"
        y1="0.000244141"
        y2="20.0002"
      >
        <stop stopColor="#FDD927" />
        <stop offset="1" stopColor="#FBB806" />
      </linearGradient>
      <clipPath id="clip0_12_212">
        <rect fill="white" height="40" transform="translate(0 0.000244141)" width="40" />
      </clipPath>
    </defs>
  </>,
  'YandexGo',
)
